


















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { practiceLib } from '@/api/task/train';
import { detail } from '@/api/task/common';
import { DOMAIN } from '@/global/constants';

@Component
export default class trainCheck extends Vue {
  private dataList: object[] = [];
  private total: number | string = 0;
  private task: any = {};

  // 搜索 入参
  private searchParams: object = {
    id: '',
    uid: '',
  };
  // 默认 入参
  private listParams: object = {
    page: 1,
    pageSize: 20,
  };

  private columnsSchema: object[] = [
    {
      title: 'ID',
      key: 'id',
      align: 'center',
    },
    {
      title: '参与练习用户ID',
      key: 'uid',
      align: 'center',
    },
    {
      title: '任务ID',
      key: 'mid',
      align: 'center',
    },
    {
      title: '审核',
      key: 'answer',
      align: 'center',
      slot: 'operate',
    },
  ];

  private created() {
    this.getList({});
    this.getTask();
  }
  private async getList(params) {
    // 列表 入参
    const new_params = Object.assign(
      { mid: this.$route.params.id },
      this.listParams,
      params
    );
    try {
      const data = (await practiceLib(new_params)) as any;
      this.$nextTick(() => {
        this.dataList = data.rows;
        this.total = data.total;
      });
    } catch (error) {
      console.log(error);
    }
  }

  private goPrev() {
    (window as any).history.back(-1);
  }
  private async getTask() {
    this.task = this.$store.state.task;
    if (!(this.task && (this.task as any).id)) {
      let data = await detail({ id: this.$route.params.id });
      this.$nextTick(() => {
        this.task =(data as any).result;
        this.$store.commit('setTask', (data as any).result);
      });
    }
  }
  // 搜索
  private handleSearch() {
    let options = {};
    const params = this.searchParams;

    for (let key in params) {
      if (params[key] !== '') {
        options[key] = params[key];
      }
    }
    this.getList(options);
  }
  // 重置
  private handlereset() {
    this.searchParams = {
      id: '',
      uid: '',
    };
    this.getList({});
  }
  // 分页
  private changePage(data) {
    (this.listParams as any).page = data;
    let options = {};
    const params = this.searchParams;
    for (let key in params) {
      if (params[key] !== '') {
        options[key] = params[key];
      }
    }
    this.getList(options);
  }
  // 切换分页条数
  private changePageSize(data) {
    (this.listParams as any).pageSize = data;
    this.changePage(1);
  }
  // 审核
  private handlecheck(id, mid) {
    window.open(`${DOMAIN}/tools/${this.task.from}.html?type=61&id=${id}&mid=${mid}`);
  }
}
